import NavBar from "../../../components/navBar";
import { useAppContext } from "context/AppContext";

type LayoutProps = {
    children: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
    const { isApp } = useAppContext();

    return (
        <div className="flex flex-col relative flex-1">
            {!isApp && (
                <div className="flex justify-center fixed top-0 left-0 w-full z-30 bg-white">
                    <NavBar
                        transport={[
                            { label: "모닝 서비스", path: "/transport/morning-service" },
                            { label: "전국센터조직도", path: "/transport/center-network" },
                            { label: "주요 CLIENT 현황", path: "/transport/clients" },
                        ]}
                        customer={[
                            { label: "인터넷오더접수", path: "/customer/online-order" },
                            { label: "운송장조회", path: "/customer/tracking" },
                            { label: "청구서조회", path: "/customer/invoices" },
                            { label: "청구서수정요청", path: "/customer/invoices-edit" },
                            { label: "운송장 신청접수", path: "/customer/tracking-request" },
                            { label: "입고지별 담당기사 조회", path: "/customer/driver-info" },
                        ]}
                        support={[
                            { label: "사용문의", path: "/support/courier-inquiry" },
                            { label: "공지사항", path: "/support/notices" },
                            { label: "FAQ", path: "/support/faq" },
                            // { label: "일신그룹 고객센터", path: "/support/tels" },
                        ]}
                    />
                </div>
            )}
            {/* <div className="w-full">{children}</div> */}
            {children}
        </div>
    );
};

export default Layout;
